export default [
  {
    id: 1,
    name: 'Declined to Report',
    label: 'Declined to Report',
    value: 'declined_to_report',
  },
  {
    id: 2,
    name: 'Hispanic',
    label: 'Hispanic',
    value: 'hispanic',
  },
  {
    id: 3,
    name: 'Non-Hispanic',
    label: 'Non-Hispanic',
    value: 'non_hispanic',
  },
];
